import type {NamedSetState} from 'app/gemStore/devtools';
import {EditRolloverDataState, EditRolloverEventType} from 'app/modules/aem/edit';

import type {AemEditSlice} from './types';

const defaultState: EditRolloverDataState = {
    componentPath: null,
    event: null,
    editedOn: null,
};

export const createAemEditSlice = (set: NamedSetState<AemEditSlice>) => ({
    aemEdit: {...defaultState},
    setAemEdit: (componentPath: string | null, event: EditRolloverEventType | null) =>
        set(
            {
                aemEdit: {
                    componentPath,
                    event,
                    editedOn: Date.now(),
                },
            },
            false,
            'aem/setAemEdit',
        ),
});
